import React from 'react';
import Typography from '@material-ui/core/Typography';
import { DateFormats } from 'UI/constants/defaults';
import { toLocalTime } from 'UI/utils';

export const Comment = ({ body, date, userName }) => {
  const formattedDate = toLocalTime(date).format(DateFormats.SimpleDateTime);
  return (
    <div>
      <Typography variant="body2">
        {userName}&nbsp;·&nbsp;{formattedDate}
      </Typography>
      <Typography variant="body1">{body}</Typography>
    </div>
  );
};
